module.exports = __webpack_public_path__ + "media/parasight.7003ab3c.webm";